import axios from 'axios'

export default function init() {
  console.log('chatwidgets init')
}

export async function list(app, widgetSettingsURL = '') {
  return axios
    .get(`${widgetSettingsURL}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let defaultErr = { message: 'Something went wrong. Please try refreshing the page' }
      if (error.response && error.response.data) defaultErr = error.response.data

      return defaultErr
    })
}

export async function add(post, app, widgetSettingsURL = '') {
  return axios
    .post(`${widgetSettingsURL}`, post, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(post, app, widgetSettingsURL = '') {
  return axios
    .put(`${widgetSettingsURL}`, post, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
